import React from 'react';

import { filterID, FilterProps } from './search_filters';
import RegionFilterOptions from './region_filter_options';

export default function RegionSelectFilter({ filter, pageSection, trackingQuery }: FilterProps) {
  const id = `${pageSection}--${filterID(filter)}`;

  return (
    <div className="facet">
      <label htmlFor={id} className="facet__heading">
        <h3>
          {filter.name}
        </h3>
      </label>
      <RegionFilterOptions
        // passed filter has selected region only
        placeholderFilter={filter}
        trackingQuery={trackingQuery}
        id={id}
      />
    </div>
  );
}
